import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { UserService } from './shared/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
 
  constructor(
    private permissionsService: NgxPermissionsService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageMap,
    private userService: UserService,
    private rs: NgxRolesService
  ) {}

  ngOnInit(): void {
    const currentVersion = '1.0.0';
    const cachedVersion = localStorage.getItem('app-version');
    
    if (cachedVersion !== currentVersion) {
      this.storage.clear().subscribe(() => {
        sessionStorage.clear();
        localStorage.setItem('app-version', currentVersion);
        
        if (cachedVersion) {
          window.location.reload();
          return;
        }
      });
      return;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const refreshToken = urlParams.get('refresh_token');
    
    if (token && refreshToken) {
      this.processThaiIdLogin(token, refreshToken);
    }
  }

    // ngOnInit(): void {
    //   // ดักจับ token จาก URL
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const token = urlParams.get('token');
    //   const refreshToken = urlParams.get('refresh_token');
      
    //   if (token && refreshToken) {
    //     this.processThaiIdLogin(token, refreshToken);
    //   }
    // }

  private processThaiIdLogin(token: string, refreshToken: string) {
    this.storage.clear().subscribe(() => {
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("accessToken", token);
      this.storage.set('token', token).subscribe(() => {
        this.userService.getUserInfo().subscribe((data) => {
          if (data) {
            this.userService.loadLogin().then((loginData: any) => {
              if (loginData != false) {
                this.permissionsService.loadPermissions(loginData.perm);
                this.rs.addRole(loginData.name, loginData.perm);
                this.storage.set('user', loginData).subscribe(() => {
                  this.router.navigate(['/'], { replaceUrl: true });
                });
              }
            });
          }
        });
      });
    });
  }
}